import { render, staticRenderFns } from "./NoClass.vue?vue&type=template&id=3e5e48c4&scoped=true"
import script from "./NoClass.vue?vue&type=script&lang=js"
export * from "./NoClass.vue?vue&type=script&lang=js"
import style0 from "./NoClass.vue?vue&type=style&index=0&id=3e5e48c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e48c4",
  null
  
)

export default component.exports